import i18n from '../locales/i18n';
import { DashboardMemberFieldType } from '../types/invites';
import { AddressGeneral, AddressUS, ProfileDataType, ProfileField, SocialType } from '../types/profile';

export function profileFieldToString(field: ProfileField): string {
  switch (field.dataType) {
    case ProfileDataType.EMAIL:
      return field.email || field.description || '';

    case ProfileDataType.BUSINESSNAME:
      return field.description || '';

    case ProfileDataType.PHONENUMBER:
      if (field.phoneNumber) {
        return `${field.phoneNumber.prefix} ${field.phoneNumber.suffix}`;
      }
      return field.description || '';

    case ProfileDataType.BIRTHDATE:
      if (field.birthDate) {
        const [year, month, day] = field.birthDate.split('-');
        return `${day}-${month}-${year}`;
      }
      return field.description || '';

    case ProfileDataType.ADDRESS:
      const addressField = field.address;
      if (!addressField) return field.description || '';

      if (addressField.countryCode === 'US') {
        const address = addressField as AddressUS;
        return `${address.streetLine} ${address.streetLineTwo || ''} ${address.zipCode}\n${address.city} ${address.state}\n${address.country}`;
      }
      const address = addressField as AddressGeneral;
      return `${address.street} ${address.houseNumber}${address.houseNumberAddition || ''}\n${
        address.postCode
      } ${address.city}\n${address.country}`;

    default:
      // Fallback to description or label for any unknown types
      return field.description || field.label || '';
  }
}

export function profileDataTypeToString(type: ProfileDataType): string {
  switch (type) {
    case ProfileDataType.EMAIL:
      return i18n.t('dataType.email');
    case ProfileDataType.PHONENUMBER:
      return i18n.t('dataType.phoneNumber');
    case ProfileDataType.BIRTHDATE:
      return i18n.t('dataType.birthDate');
    case ProfileDataType.ADDRESS:
      return i18n.t('dataType.address');
    case ProfileDataType.BUSINESSNAME:
      return i18n.t('dataType.businessName');
    default:
      return '';
  }
}

export function dashboardMemberFieldTypeToString(type: DashboardMemberFieldType): string {
  if ((type as SocialType) in SocialType) return capitalizeFirstLetter(type as string);
  return profileDataTypeToString(type as ProfileDataType);
}
export function joinWithAnd(strings: string[]): string {
  if (strings.length === 0) return '';
  if (strings.length === 1) return strings[0];
  return `${strings.slice(0, strings.length - 1).join(', ')} ${i18n.t('general.and')} ${strings[strings.length - 1]}`;
}

export function capitalizeFirstLetter(x: string) {
  const lowerCase = x.toLocaleLowerCase();
  return lowerCase.charAt(0).toUpperCase() + lowerCase.slice(1);
}

export function getInitials(alias: string): string {
  return alias
    .split('+')
    .map((x) => x.split(' '))
    .flat()
    .map((x) => x[0])
    .join('');
}

// Function to capitalize each word in a string
export function capitalizeWords(str: string): string {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
}
